/**
 * The states of the requisition — the ask before the order
 * (docs/MATERIALNO-ZAHTEVKI.md, WP-M4).
 *
 * They mirror `DataStructures/StockRequisition.go`. Two sets and not one: the
 * requisition's own life has six rungs and a single approver's answer has three, and
 * folding them together would give a filter offering „v čakanju“ over a list of papers
 * where nobody is waiting for anything.
 */

/**
 * The requisition's ladder.
 *
 * `Ordered` is the one nobody presses twice: the purchase orders written from an
 * approved requisition move it there, and the screens draw it rather than offering it.
 */
export enum RequisitionStatus {
    Draft     = 'draft',
    Submitted = 'submitted',
    Approved  = 'approved',
    Rejected  = 'rejected',
    Ordered   = 'ordered',
    Cancelled = 'cancelled',
}

/** One approver's answer on one rung. `Pending` is a rung nobody has answered yet. */
export enum RequisitionDecision {
    Pending  = 'pending',
    Approved = 'approved',
    Rejected = 'rejected',
}

/**
 * How many signatures a rule may ask for.
 *
 * Two and not more, deliberately: the ladder exists so that spending above a figure
 * reaches somebody who may commit it, and a third rung is a purchase nobody makes.
 */
export enum ApprovalRuleLevel {
    First  = 1,
    Second = 2,
}
